<app-header></app-header>
<div class="content" >
    <router-outlet></router-outlet>
</div>
<app-page-loader></app-page-loader>
